import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    private auth = inject(AuthService);
    private router = inject(Router);

    constructor() { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.auth.isAuthenticated$.pipe(
            take(1),
            map(isAuth => {
                if (!isAuth) {
                    // Preserve query parameters when redirecting to signin
                    const queryParams = route.queryParams;
                    this.router.navigate(['/'], { queryParams });
                    return false;
                }
                return true;
            })
        );
    }
}
